import Component from '@glimmer/component';

export default class MwIconsWithTextIcon extends Component {}
